import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')``;

export const InfoBox = styled('div')`
  background: ${theme.palette.background.default};
  border-radius: 8px;
  padding: 16px;
`;

export const Title = styled('div')`
  color: ${theme.palette.text.dark};
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const Info = styled('div')`
  display: flex;
  align-items: start;
  justify-content: flex-start;
  flex-wrap: wrap-reverse;
  color: ${theme.palette.text.dark};
  font-size: 14px;

  > div {
    margin-right: 50px;
  }

  .item {
    .label {
      display: inline-block;
      color: ${theme.palette.secondary.main};
      width: 170px;
    }
  }

  button {
    margin-top: 16px;
  }
`;

export const Spacer = styled('div')`
  margin-bottom: 16px;
`;